import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "LogOutWidget" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "NavigatorButton LogOutButton",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut()))
    }, " Sign out "),
    _createElementVNode("button", {
      class: "Textlink LogOutDismissButton",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideWidget()))
    }, " Hide ")
  ]))
}